var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.showError),expression:"showError"}],staticClass:"error-message",style:({ position: !_vm.absolute ? 'static' : null })},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }